import { BrandIdentityGuideGeneratedFieldNameSchema } from "@redotech/redo-model/agents/aeo-agents/brand-identity-guide";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateMerchantBrandIdentityGuide = unaryRpc({
  name: "generateMerchantBrandIdentityGuide",
  input: z.object({
    teamId: zExt.objectId(),
    fieldsToRegenerate: z
      .array(BrandIdentityGuideGeneratedFieldNameSchema)
      .optional(),
  }),
  output: z.object({ success: z.boolean() }),
});
